import { ClaimToolAssociatedImagePayload } from "./claim-tool-associated-image";
import { CatDocStateTagEnum} from "./cat.model";
import { ClaimToolElementSaveChangesData } from "./claim-tool-element-save-changes-data.model";
import { AssociatedImage, AssociatedTextPhrase, GrammarSpellingIssue, PhraseWord, ReferenceIssue, ReferencePhrase } from "./common";
import { DocPhraseMergeAndReorder } from "./doc-phrase-merge-and-reorder.model";
import { SplitPhrase } from "./split-phrase.model";

export class ClaimToolElement {
    phraseWords: PhraseWord[] = [];
    phraseId: number;
    docId: number;
    isPrecheck: boolean;
    runType: string;
    stateTag?: CatDocStateTagEnum;
    envId: number;
    catVersionId: number;
    contentTypeDesc: string;
    pageNum: number;

    claimToolElementSaveChangesData: ClaimToolElementSaveChangesData = new ClaimToolElementSaveChangesData();

    get references() {

        return this.claimToolElementSaveChangesData.references;
    }

    get deletedReferences() {

        return this.claimToolElementSaveChangesData.deletedReferences;
    }

    get associatedText() {

        return this.claimToolElementSaveChangesData.associatedText;
    }

    get deletedAssociatedText() {

        return this.claimToolElementSaveChangesData.deletedAssociatedText;
    }

    get associatedImages() {
        return this.claimToolElementSaveChangesData.associatedImages;
    }

    get deletedAssociatedImages() {
        return this.claimToolElementSaveChangesData.deletedAssociatedImages;
    }

    get contentType() {

        return this.claimToolElementSaveChangesData.contentType;
    }

    get mergedPhrases() {

        return this.claimToolElementSaveChangesData.mergedPhrases;
    }

    get splitPhrases() {
        return this.claimToolElementSaveChangesData.splitPhrases;
    }

    get phrasesOrder() {

        return this.claimToolElementSaveChangesData.phrasesOrder;
    }
    get phraseSubTypeCode() {

        return this.claimToolElementSaveChangesData.phraseSubTypeCode;
    }
    get phraseTypeCode() {

        return this.claimToolElementSaveChangesData.phraseTypeCode;
    }

    get phraseTypeCodeDescr() {
        return this.claimToolElementSaveChangesData.phraseTypeCodeDescr;    
    }
    get phraseSubTypeCodeDescr() {
        return this.claimToolElementSaveChangesData.phraseSubTypeCodeDescr;      
    }

    set phraseSubTypeCodeDescr(phraseSubTypeCodeDescr: string) {
        this.claimToolElementSaveChangesData.phraseSubTypeCodeDescr = phraseSubTypeCodeDescr;
    }

    set phraseTypeCodeDescr(phraseTypeCodeDescr: string) {
        this.claimToolElementSaveChangesData.phraseTypeCodeDescr = phraseTypeCodeDescr;   
    }

    set phraseTypeCode(phraseTypeCode: string) {
        this.claimToolElementSaveChangesData.phraseTypeCode = phraseTypeCode;   
    }

    set phraseSubTypeCode(phraseSubTypeCode: string) {
        
        this.claimToolElementSaveChangesData.phraseSubTypeCode = phraseSubTypeCode;   
    }

    set phrasesOrder(phrasesOrder: DocPhraseMergeAndReorder[]) {

        this.claimToolElementSaveChangesData.phrasesOrder = phrasesOrder;
    }
    
    set contentType(contentType: string) {
        
        this.claimToolElementSaveChangesData.contentType = contentType;
    }

    set associatedText(associatedText: AssociatedTextPhrase[]) {
        
        this.claimToolElementSaveChangesData.associatedText = associatedText;
    }

    set deletedAssociatedText(deletedAssociatedText: AssociatedTextPhrase[]) {
        
        this.claimToolElementSaveChangesData.deletedAssociatedText = deletedAssociatedText;
    }

    set associatedImages(associatedImages: ClaimToolAssociatedImagePayload[]) {
        this.claimToolElementSaveChangesData.associatedImages = associatedImages;
    }

    set deletedAssociatedImages(deletedAssociatedImages: ClaimToolAssociatedImagePayload[]) {
        this.claimToolElementSaveChangesData.deletedAssociatedImages = deletedAssociatedImages;
    }

    set references(references: ReferencePhrase[]) {

        this.claimToolElementSaveChangesData.references = references;
    }

    set deletedReferences(deletedReferences: ReferencePhrase[]) {
        
        this.claimToolElementSaveChangesData.deletedReferences = deletedReferences;
    }

    set mergedPhrases(mergedPhrases: DocPhraseMergeAndReorder[]) {
        
        this.claimToolElementSaveChangesData.mergedPhrases = mergedPhrases;
    }

    set splitPhrases(splitPhrases: SplitPhrase[]) {
        this.claimToolElementSaveChangesData.splitPhrases = splitPhrases;
    }


}